import type { ReactElement } from "react";
import useEditorRedirect from "./use-editor-redirect";
import useGetInitialUserData from "./use-get-initial-user-data";
import useIntervalRefresh from "./use-interval-refresh";

interface AuthWrapperProps {
  children: ReactElement;
}

const AuthWrapper = ({ children }: AuthWrapperProps): ReactElement => {
  useEditorRedirect();
  useIntervalRefresh();
  useGetInitialUserData();

  return children;
};

export default AuthWrapper;
